export { default } from './EditArticle'
